var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".medium-editor-element{outline:none}.color-1,.color-2,.medium-editor-toolbar li button,a,a:hover,section.splash h1 span{color:#404040}.medium-editor-button-active b,body,code,pre{color:#2c3e50}.medium-editor-button-active.medium-editor-button-active.medium-editor-button-active{background-color:#4fc08d}code,pre{background:#f8f8f8;width:80vw}code.data,pre#cdn,pre#usage{max-width:900px}code.data{margin-top:50px}.medium-toolbar-arrow-over:before{border-color:transparent transparent #2c3e50}.medium-editor-toolbar li button{border-right:1px solid #2c3e50}.github-fork-ribbon,.medium-editor-toolbar,.medium-editor-toolbar-anchor-preview,section.installation{background:#2c3e50}.medium-toolbar-arrow-under:after{background:url(" + escape(require("../images/down_pointer.png")) + ") no-repeat;width:17px;height:13px;border:0!important;bottom:-10px}#toolbar-placeholder{display:none}.medium-editor-toolbar{transition:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/content/css/medium-editor-custom.css
// module id = 421
// module chunks = 0